<script setup>
import { ref, defineProps } from 'vue';
import { useBackLayer } from '@/composables/useAppBack';

const router = useRouter();
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  titleClass: {
    type: String,
    default: '',
  },
  title2: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
  nextUrl: {
    type: [String, Function],
    default: '',
  },
  doFun: {
    type: Function,
    default: null,
  },
});

const isAlertDialogVisible = ref(false);

const closeAlertDialog = () => {
  isAlertDialogVisible.value = false;
  if (typeof props.nextUrl === 'function') {
    props.nextUrl();
    return;
  }
  if (props.nextUrl) {
    router?.push(props.nextUrl);
    return;
  }
  if (props.doFun) {
    props.doFun();
  }
};

const close = () => {
  isAlertDialogVisible.value = false;
};

const openAlertDialog = () => {
  isAlertDialogVisible.value = true;
};

useBackLayer({
  id: 'common-alert',
  isOpen: isAlertDialogVisible,
  closeFromBack: close,
});

// 다이얼로그를 여는 메서드를 외부에서 호출할 수 있도록
defineExpose({ isAlertDialogVisible, openAlertDialog, close });
</script>

<template>
  <Teleport to="body">
    <VRow
      v-model="isAlertDialogVisible"
      class="v-dialog-alert"
      :class="isAlertDialogVisible ? 'active' : ''"
    >
      <div class="back-full-layer">
        <div class="alert-wrap">
          <div class="tit-box">
            <div :class="titleClass">{{ title }}</div>
            <div class="confirm-title-text" v-if="title2">{{ title2 }}</div>
          </div>
          <div class="text-box" v-if="text">
            {{ text }}
          </div>
          <div class="btn-box">
            <button class="btn-nor" @click="closeAlertDialog">확인</button>
          </div>
        </div>
      </div>
    </VRow>
  </Teleport>
</template>

<style scoped>
.tit-box {
  white-space: pre-line;
}

.dialog-title {
  text-align: center;
}

.confirm-date-text {
  font-family: Pretendard;
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-top: -3px;
}

.confirm-title-text {
  color: var(--Gray-800, #333);
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
}
</style>
